module.exports = __webpack_public_path__ + "static/img/detailImgbb.b8558ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/detailImgbb.jpg
// module id = S4TK
// module chunks = 6